import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import Search from '../search/search'
import Dlogo from './Dlogo'
import { connect } from 'react-redux'

const Logo = require('../../img/radyodlogo-mobile.png?v=2');
const LogoSb = require('../../img/radyodlogosb.png?v=2');
const LogoRibbon = require('../../img/rbw.png?v=2');

const menu = [
    {
        text: 'PROGRAM',
        url: '/program',
    },
    {
        text: `PODCAST`,
        url: '/podcast',
    },
    {
        text: 'YAYIN AKIŞI',
        url: '/yayin-akisi',
    },
    {
        text: 'FREKANS',
        url: '/frekans',
    },
    {
        text: 'TOP20',
        url: '/top20',
    },
    {
        text: 'HABER GALERİ',
        url: '/haber-galeri',
    },
    {
        text: 'ETKİNLİKLER',
        url: '/etkinlikler',
    },
]

class Header extends Component {
    constructor(props) {
        super(props)
        this.state = {
            scrollOnTop: true,
            menuScrollEnd: false,
            active: 'home',
            isSearch: false,
            IsNationalMourning : false
        }        
    }

    onChangeIsSearch = (value) => {
        this.setState({ isSearch: value })
        if (value) document.querySelector('html').classList.add('search-active')
        else document.querySelector('html').classList.remove('search-active')
    }    

    async componentWillMount() {
        try {
            let responseIsNationalMourning = await fetch(this.props.config.ConfigurationUrl + '?key=IsNationalMourning');
            let IsNationalMourning = await responseIsNationalMourning.json();
            this.setState({ IsNationalMourning: IsNationalMourning[0].Value == 'true' })
        } catch (err) {
            console.error(err.message);
        }
    }

    componentDidMount() {        
        window.addEventListener('scroll', () => {
            this.setState({ scrollOnTop: window.scrollY === 0 })
        })               
    }

    onMenuScroll = (e) => {
        const currentScroll = e.target.scrollLeft
        const maxScroll = e.target.scrollWidth - e.target.clientWidth
        this.setState({ menuScrollEnd: currentScroll === maxScroll })
    }

    renderLogo() {
        if (this.state.IsNationalMourning) {
            return (
                <>
                    <img src={LogoSb} alt="Ulusal yas" />
                    <img src={LogoRibbon} alt="Ulusal yas" />
                </>
            );
        } else {
            return <img src={Logo} alt="Radyo D" />;            
        }
    }

    render() {        
        return (
            <header className={!this.state.scrollOnTop ? 'blur' : ''}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 header-area header-area-wrapper">
                            <h1 className="logo">
                                <Link to="/" onClick={() => this.setState({ active: 'home' })}>                                    
                                    {this.renderLogo()}
                                </Link>
                            </h1>
                            <Link to={'/frekans'} className="frequency">
                                <div className="frequency-item">
                                    İSTANBUL
                                    <span>104.0</span>
                                </div>
                            </Link>
                            <a href="https://wa.me/905492040104?text=Merhaba" className="whatsapp" target="_blank" rel="noopener noreferrer">
                                <div className="whatsapp-item">
                                    WHATSAPP HATTI
                                    <span>0 (549) 204 0 104</span>
                                </div>
                            </a>
                            <span onClick={() => this.onChangeIsSearch(true)} className="search-button">
                                <i className="fa fa-search"></i>
                            </span>
                        </div>
                        <div className="col-12 col-md-12 col-lg-8 navbar">
                            <nav onScroll={(e) => this.onMenuScroll(e)} className="main-nav">
                                <Link
                                    to="/"
                                    onClick={() => this.setState({ active: null })}
                                    className="to-top-btn"
                                ></Link>

                                <ul className={this.state.menuScrollEnd ? 'main-nav-list' : 'main-nav-list end'}>
                                    {menu.map((item, index) => (
                                        <li key={index} className="main-nav-item">
                                            {item.text === 'PODCAST' ? (
                                                <Link
                                                    to={item.url}
                                                    className={
                                                        this.state.active === item.text
                                                            ? 'main-nav-link active'
                                                            : 'main-nav-link'
                                                    }
                                                    onClick={() => this.setState({ active: item.text })}
                                                >
                                                    {item.text}{' '}
                                                    <svg
                                                        className="ml-3"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="14"
                                                        height="19"
                                                        viewBox="0 0 14 19"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M13.5504 6.9419V9.50004C13.5477 11.1409 12.9354 12.7223 11.8324 13.9372C10.7294 15.152 9.2144 15.9138 7.58139 16.0745V18.0272C7.58139 18.1968 7.51401 18.3595 7.39408 18.4794C7.27414 18.5993 7.11147 18.6667 6.94186 18.6667C6.77224 18.6667 6.60958 18.5993 6.48964 18.4794C6.3697 18.3595 6.30232 18.1968 6.30232 18.0272V16.0745C4.66932 15.9138 3.15428 15.152 2.05128 13.9372C0.948282 12.7223 0.336016 11.1409 0.333332 9.50004V6.9419C0.333332 6.77229 0.400711 6.60962 0.520647 6.48968C0.640583 6.36975 0.803252 6.30237 0.972867 6.30237C1.14248 6.30237 1.30515 6.36975 1.42509 6.48968C1.54502 6.60962 1.6124 6.77229 1.6124 6.9419V9.50004C1.6124 10.9135 2.1739 12.2691 3.17336 13.2685C4.17283 14.268 5.5284 14.8295 6.94186 14.8295C8.35532 14.8295 9.71089 14.268 10.7104 13.2685C11.7098 12.2691 12.2713 10.9135 12.2713 9.50004V6.9419C12.2713 6.77229 12.3387 6.60962 12.4586 6.48968C12.5786 6.36975 12.7412 6.30237 12.9109 6.30237C13.0805 6.30237 13.2431 6.36975 13.3631 6.48968C13.483 6.60962 13.5504 6.77229 13.5504 6.9419ZM2.89147 9.50004V4.38376C2.89147 3.30953 3.31821 2.2793 4.0778 1.5197C4.8374 0.76011 5.86763 0.333374 6.94186 0.333374C8.01609 0.333374 9.04632 0.76011 9.80592 1.5197C10.5655 2.2793 10.9922 3.30953 10.9922 4.38376V9.50004C10.9922 10.5743 10.5655 11.6045 9.80592 12.3641C9.04632 13.1237 8.01609 13.5504 6.94186 13.5504C5.86763 13.5504 4.8374 13.1237 4.0778 12.3641C3.31821 11.6045 2.89147 10.5743 2.89147 9.50004ZM5.44961 5.23647C5.45182 5.4054 5.51991 5.56679 5.63937 5.68625C5.75883 5.80571 5.92022 5.8738 6.08915 5.87601H7.79457C7.96419 5.87601 8.12686 5.80863 8.24679 5.68869C8.36673 5.56876 8.43411 5.40609 8.43411 5.23647C8.43411 5.06686 8.36673 4.90419 8.24679 4.78426C8.12686 4.66432 7.96419 4.59694 7.79457 4.59694H6.08915C5.92022 4.59915 5.75883 4.66724 5.63937 4.7867C5.51991 4.90616 5.45182 5.06755 5.44961 5.23647ZM5.44961 8.64733C5.45182 8.81626 5.51991 8.97764 5.63937 9.0971C5.75883 9.21656 5.92022 9.28465 6.08915 9.28686H7.79457C7.96419 9.28686 8.12686 9.21948 8.24679 9.09955C8.36673 8.97961 8.43411 8.81694 8.43411 8.64733C8.43411 8.47771 8.36673 8.31504 8.24679 8.19511C8.12686 8.07517 7.96419 8.00779 7.79457 8.00779H6.08915C5.92022 8.01 5.75883 8.07809 5.63937 8.19755C5.51991 8.31701 5.45182 8.4784 5.44961 8.64733Z"
                                                        />
                                                    </svg>
                                                    {/* {<Dlogo text={item.text}/>} */}
                                                </Link>
                                            ) : (
                                                <Link
                                                    to={item.url}
                                                    className={
                                                        this.state.active === item.text
                                                            ? 'main-nav-link active'
                                                            : 'main-nav-link'
                                                    }
                                                    onClick={() => this.setState({ active: item.text })}
                                                >
                                                    {item.text}
                                                    {/* {<Dlogo text={item.text}/>} */}
                                                </Link>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                <span onClick={() => this.onChangeIsSearch(true)} className="search-button">
                                    <i className="fa fa-search"></i>
                                </span>
                            </nav>
                        </div>
                    </div>
                </div>
                {this.state.isSearch && <Search onClose={() => this.onChangeIsSearch(false)} />}
            </header>
        )
    }
}

const mapStateToProps = (state) => ({ ...state.radioReducer })
const header = withRouter(props => <Header {...props} />)
const headerWithRouter = connect(mapStateToProps)(header);

export default headerWithRouter;
